import React, { Component } from 'react';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { t } from '../../../../../locales';
import DashboardCardScenario from '../index';
import img from '../../../../../assets/images/vhis/dashboard/ico-eroll@3x.png';
import { ENTITY_CODE } from '../../../../../constants/constants';

interface ScenarioEnrollmentProps {
  policyNumber: string;
  entityCode: string;
}

class ScenarioEnrollment extends Component<ScenarioEnrollmentProps> {
  render() {
    const { policyNumber, entityCode } = this.props;
    const text =
      entityCode === ENTITY_CODE.LMA
        ? t('AXA_GOAL_SCENAVIO_ENROLLMENT_TEXT_MACAU')
        : t('AXA_GOAL_SCENAVIO_ENROLLMENT_TEXT_HK');
    const props = {
      imageIcon: img,
      text,
      buttonText: t('AXA_GOAL_SCENAVIO_ENROLLMENT_BUTTON_TEXT'),
      clickButton: () => {
        if (policyNumber && entityCode) {
          const link = `emma-vhis/intro?policyNumber=${policyNumber}&entityCode=${entityCode}`;
          EmmaFactory.createInstance().then((e) => {
            e.instance && e.instance.goTo && e.instance.goTo(link);
          });
        }
      },
    };
    return <DashboardCardScenario {...props} />;
  }
}

export default ScenarioEnrollment;
